export const redirectMap = {
  201: 'campaigns',
  202: 'campaign-create-objective',
  203: 'audiences',
  204: 'uet-tag',
  205: 'structuredsnippet',
  206: 'callout',
  207: 'image',
  208: 'review',
  209: 'location',
  210: 'app',
  211: 'call',
  212: 'audiences-library',
  213: 'shared-budgets',
};
